import { ref as p, onBeforeUnmount as u, resolveComponent as d, openBlock as c, createBlock as m, withCtx as f, createElementBlock as _, Fragment as v, renderList as x } from "vue";
import T from "./design-system.es4.js";
import h from "./design-system.es3.js";
import g from "./design-system.es6.js";
import L from "./design-system.es128.js";
const k = {
  name: "DsToastContainer",
  components: {
    ToastGroup: T,
    Toast: h
  },
  props: {
    position: {
      type: String,
      default: "end",
      validator: (e) => ["start", "center", "end"].includes(e)
    }
  },
  setup() {
    const e = p([]), n = p(1), { emitter: a } = g(), t = (r) => {
      e.value.push({
        ...r,
        id: `toast_${n.value}`
      }), n.value += 1;
    }, l = (r) => {
      const s = e.value.findIndex((i) => i.id === r.id);
      e.value.splice(s, 1);
    };
    return a.on("open", t), u(() => {
      a.off("open", t);
    }), {
      toasts: e,
      nextId: n,
      handleAfterLeave: l
    };
  }
};
function A(e, n, a, t, l, r) {
  const s = d("Toast"), i = d("ToastGroup");
  return c(), m(i, { position: a.position }, {
    default: f(() => [
      (c(!0), _(v, null, x(t.toasts, (o) => (c(), m(s, {
        key: o.id,
        message: o.message,
        headline: o.headline,
        "action-text": o.actionText,
        action: o.action,
        onAfterLeave: (B) => t.handleAfterLeave(o)
      }, null, 8, ["message", "headline", "action-text", "action", "onAfterLeave"]))), 128))
    ]),
    _: 1
  }, 8, ["position"]);
}
const b = /* @__PURE__ */ L(k, [["render", A]]);
export {
  b as default
};
//# sourceMappingURL=design-system.es5.js.map
